import { render, staticRenderFns } from "./abnormalGoods.vue?vue&type=template&id=4f5845ea&scoped=true&"
import script from "./abnormalGoods.vue?vue&type=script&lang=js&"
export * from "./abnormalGoods.vue?vue&type=script&lang=js&"
import style0 from "./abnormalGoods.vue?vue&type=style&index=0&id=4f5845ea&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5845ea",
  null
  
)

export default component.exports